(() => {
 const carousel=document.querySelector('.community-carousel');
 if(!carousel)return;
 const slides=[...carousel.querySelectorAll('.community-slide')];
 const dots=[...carousel.querySelectorAll('.slide-dot')];
 const pause=carousel.querySelector('.slide-pause');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let index=0,playing=!reduced.matches,timer,startX=null;
 const render=()=>{slides.forEach((s,i)=>s.hidden=i!==index);dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===index)));carousel.querySelector('.slide-count').textContent=`${index+1} / ${slides.length}`;};
 const stop=()=>clearInterval(timer);
 const resume=()=>{stop();if(playing&&!document.hidden)timer=setInterval(()=>{index=(index+1)%slides.length;render();},5500);};
 const show=i=>{index=(i+slides.length)%slides.length;render();resume();};
 const setPlaying=value=>{playing=value;pause.textContent=playing?'Pause':'Play';resume();};
 carousel.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>show(index+Number(b.dataset.direction))));
 dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));
 pause.addEventListener('click',()=>setPlaying(!playing));
 carousel.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(index+(e.key==='ArrowLeft'?-1:1));}});
 carousel.addEventListener('pointerdown',e=>startX=e.clientX);
 carousel.addEventListener('pointerup',e=>{if(startX!==null&&Math.abs(e.clientX-startX)>45)show(index+(e.clientX<startX?1:-1));startX=null;});
 carousel.addEventListener('pointercancel',()=>startX=null);
 carousel.addEventListener('mouseenter',stop);
 carousel.addEventListener('mouseleave',resume);
 carousel.addEventListener('focusin',stop);
 carousel.addEventListener('focusout',()=>setTimeout(()=>{if(!carousel.contains(document.activeElement))resume();},0));
 document.addEventListener('visibilitychange',()=>document.hidden?stop():resume());
 reduced.addEventListener('change',()=>{if(reduced.matches)setPlaying(false);});
 setPlaying(playing);
})();
